module.exports = __webpack_public_path__ + "92c00e8323b0ce2edd71c28c3e2f7f2a.jpg";